import { ImageModel } from '../ImageModel';
import { LinkModel } from '../LinkModel';
import { TaxonomyModel } from '../TaxonomyModel';

export enum ReportFormat {
  Report = 'Report',
  // TODO add other formats
}

export type ReportSearchModel = {
  format: ReportFormat;
  title: string;
  description: string;
  shortenedDescription: string;
  image?: ImageModel;
  publishedDate: Date;
  reportUrl: LinkModel;
  reportId: number;
  directory: TaxonomyModel;
  authors: TaxonomyModel[];
  readTime: string;
  audioAvailable: boolean;
  anchorTextColour: string;
  hideTitleOnAnchor?: boolean;
  thumbnailBackgroundColour: string;
  isLegacy?: boolean;
  isLoading?: boolean;
  isActive?: boolean;
  isGdReport?: boolean;
};
